import * as React from 'react'
import { motion } from 'framer-motion'
import { twMerge } from 'tailwind-merge'

export type ActionPopoverScreenProps = {
  id: string
  key: string
  isActive: boolean
  children: React.ReactNode
  className?: string
  animation?: {
    initial: Record<string, number>
    animate: Record<string, number>
    exit: Record<string, number>
  }
}

const defaultActionsAnimation = {
  initial: {
    opacity: 0,
    filter: 'blur(4px)',
  },
  animate: {
    opacity: 1,
    filter: 'blur(0px)',
  },
  exit: {
    opacity: 0,
    filter: 'blur(4px)',
  },
  transition: {
    type: 'spring' as const,
    stiffness: 550,
    damping: 45,
  },
}

const ActionPopoverScreen = React.forwardRef<HTMLDivElement, ActionPopoverScreenProps>(
  ({ id, key: screenKey, isActive, children, className, animation }, ref) => {
    if (!isActive) return null

    // Ensure key is never empty by using screenKey as fallback
    const motionKey = id ? `${screenKey}-${id}` : screenKey

    return (
      <motion.div
        ref={ref}
        key={motionKey}
        className={twMerge('flex items-center gap-1', className)}
        {...(animation ?? defaultActionsAnimation)}
      >
        {children}
      </motion.div>
    )
  },
)

export { ActionPopoverScreen }
